import React from 'react';
import { getEntity } from '../../constants/entityRegistry';
import './EntityIcon.css';

const ICON_SIZES = { sm: 12, md: 14, lg: 18 };

/**
 * Renders an entity type icon — consistently styled across the platform.
 * Uses Lucide SVG icons from the central entity registry.
 *
 * @param {string}  type       - Entity type key (e.g. 'node', 'schema', 'plugin')
 * @param {boolean} showLabel  - Show the label text next to the icon (badge mode)
 * @param {string}  size       - 'sm' | 'md' | 'lg'
 * @param {string}  className  - Additional CSS class
 */
export default function EntityIcon({ type, showLabel = false, size = 'sm', className = '' }) {
  const meta = getEntity(type);
  const IconComponent = meta.icon;
  const iconPx = ICON_SIZES[size] || ICON_SIZES.sm;

  return (
    <span
      className={`entity-icon entity-icon--${size} ${showLabel ? 'entity-icon--labeled' : ''} ${className}`}
      style={{ color: meta.color, backgroundColor: showLabel ? meta.bg : undefined }}
    >
      <IconComponent size={iconPx} strokeWidth={2} />
      {showLabel && <span className="entity-icon__label">{meta.label}</span>}
    </span>
  );
}
